(() => {
const $e1f0b8fa1ae2171c$var$React = window.React;
function $e1f0b8fa1ae2171c$export$bdc7c5cd37699390() {
    document.getElementById('digioh-form-wrapper')?.remove();
}
function $e1f0b8fa1ae2171c$export$6f3bb5b44fd52b9a(visible = true) {
    const elForm = document.querySelector('#lightbox-inline-webinar-form');
    if (elForm) elForm.style.opacity = visible ? '1' : '0';
}
function $e1f0b8fa1ae2171c$export$eae3ab9a391c6ffd(v) {
    const match = DIGIOH_LIGHTBOX_CONDITIONS.find((item)=>{
        if (!item.conditions || !Array.isArray(item.conditions)) return false;
        return item.conditions.some((group)=>Array.isArray(group) && group.some((cond)=>cond.v && cond.v.includes(v)));
    });
    if (!match) return null;
    const guid = match.lightbox_guid;
    const name = window.DIGIOH_LIGHTBOX_NAMES[guid] || null;
    return name;
}
function $e1f0b8fa1ae2171c$export$2e2bcd8739ae039() {
    if (adw?.webinar_meta?.registration_url) return "aw_webinar_" + btoa(adw.webinar_meta.registration_url);
    else if (adw?.webinar_meta?.event_id) return "aw_webinar_" + btoa(adw.webinar_meta.event_id);
    return null;
}
async function $e1f0b8fa1ae2171c$export$82de835bb8638b43({ fieldValues: fieldValues, email: email, password: password }) {
    const user = {
        identifiers: {
            email_address: email
        },
        attributes: fieldValues
    };
    if (password) user['validators'] = {
        password: password
    };
    const response = await fetch(`${window.location.origin}/blaize/register`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        },
        body: JSON.stringify(user)
    });
    const data = await response.json();
    return {
        ...data,
        ok: response.ok,
        status: response.status || data?.status
    };
}
async function $e1f0b8fa1ae2171c$export$4bb8fcd6ff31955b(email) {
    const body = new URLSearchParams({
        action: 'adw_zephr_check_user_email_exist',
        email: email
    });
    const response = await fetch(window.zephr_object.ajaxurl, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
        },
        body: body.toString()
    });
    if (!response.ok) throw new Error(`Zephr User existence check failed with status ${response.status}`);
    const result = await response.json();
    if (typeof result?.success !== 'boolean') throw new Error('Zephr User existence check returned an invalid response');
    return result.success;
}
async function $e1f0b8fa1ae2171c$export$d2da082481fe41f({ email: email, action: action = 'login' }) {
    try {
        const response = await fetch(`${window.location.origin}/blaize/token-exchange`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            body: JSON.stringify({
                "identifiers": {
                    "email_address": email
                },
                "delivery": {
                    "method": "email",
                    "destination": email,
                    "action": action,
                    "redirect": window.location.href
                }
            }),
            credentials: 'include'
        });
        if (!response.ok) throw new Error(`Zephr token exchange failed with status ${response.status}`);
        return response;
    } catch (err) {
        console.error("Error in Zephr Passwordless Auth", err);
        throw err;
    }
}
const $e1f0b8fa1ae2171c$export$3a09f6f0b9fa7cb9 = (email = '', unset = false)=>{
    const localStorageKey = $e1f0b8fa1ae2171c$export$2e2bcd8739ae039();
    if (unset) localStorage.removeItem(localStorageKey);
    else localStorage.setItem(localStorageKey, JSON.stringify(btoa(email)));
};
const $e1f0b8fa1ae2171c$export$cb7776dcba1aa2 = ()=>{
    const localStorageKey = $e1f0b8fa1ae2171c$export$2e2bcd8739ae039();
    if (!localStorageKey) return false;
    const localStorageValue = localStorage.getItem(localStorageKey);
    if (localStorageValue) return JSON.parse(atob(localStorageValue));
    return false;
};
const $e1f0b8fa1ae2171c$export$3872c79dafc63da2 = (email)=>{
    if (typeof Cookies === 'function') {
        const cookieKey = $e1f0b8fa1ae2171c$export$2e2bcd8739ae039();
        if (!cookieKey) throw new Error('No cookie key available');
        Cookies.set(cookieKey, JSON.stringify(btoa(email)), {
            expires: 30
        });
    }
};
const $e1f0b8fa1ae2171c$export$4555dbaf6c217ba2 = ()=>{
    if (typeof Cookies === 'function') {
        const cookieKey = $e1f0b8fa1ae2171c$export$2e2bcd8739ae039();
        if (!cookieKey) throw new Error('No cookie key available');
        const cookieValue = Cookies.get(cookieKey);
        if (cookieValue) return atob(JSON.parse(cookieValue));
    }
    return false;
};
const $e1f0b8fa1ae2171c$export$c52aecb04e8f29cd = ()=>{
    return $e1f0b8fa1ae2171c$export$4555dbaf6c217ba2() || $e1f0b8fa1ae2171c$export$cb7776dcba1aa2();
};
const $e1f0b8fa1ae2171c$export$680d6313e5f8249a = (email = '')=>{
    $e1f0b8fa1ae2171c$export$3872c79dafc63da2(email);
    $e1f0b8fa1ae2171c$export$3a09f6f0b9fa7cb9(email);
    adw.webinar_meta.is_registered = true;
};
const $e1f0b8fa1ae2171c$export$14113472834e2950 = function(args, postId = null) {
    return new Promise((resolve, reject1)=>{
        const params = new URLSearchParams();
        for(const key in args)params.set(key, args[key]);
        // Add post ID to params if available
        if (postId) params.set('post_id', postId);
        const queryString = params.toString();
        // If registration_url is set in post meta, use the new default registration flow
        const registrationUrl = adw?.webinar_meta?.registration_url;
        if (registrationUrl) {
            const { fname: fname, lname: lname, email: email, firstName: firstName, lastName: lastName, emailAddress: emailAddress, ...additionalFields } = args;
            const registrationPayload = {
                firstName: firstName || fname || '',
                lastName: lastName || lname || '',
                emailAddress: emailAddress || email || '',
                ...additionalFields
            };
            const requestPayload = {
                ...registrationPayload,
                post_id: Number(postId || adw?.post?.id || 0),
                registration_url: registrationUrl
            };
            fetch(`${window.location.origin}/wp-json/adw_webinar_registration/v1/registration/`, {
                method: 'POST',
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(requestPayload)
            }).then((response)=>{
                return response?.json?.() || {};
            }).then((response)=>{
                return resolve(response);
            }).catch((error)=>reject1(error));
        } else // To-Do: Remove this legacy registration flow after confirming all clients have updated to the new flow that uses the registration_url post meta field
        fetch(`${window.location.origin}/wp-json/adw-webcasts/v1/register_user/?${queryString}`).then((response)=>{
            if (response.status !== 200) return reject1();
            const contentType = response.headers.get('content-type') || '';
            if (contentType.includes('application/json')) return response.json();
            return response.text().then((text)=>{
                try {
                    return JSON.parse(text);
                } catch (err) {
                    return text;
                }
            });
        }).then((response)=>resolve(response)).catch((error)=>reject1(error));
        // Send data to BigQuery
        $e1f0b8fa1ae2171c$var$sendRegistrationDataToBigQuery(queryString);
    });
};
function $e1f0b8fa1ae2171c$var$isProductionDomain() {
    const host = window.location.host;
    return host === "www.adweek.com" || host === "adweek.com";
}
function $e1f0b8fa1ae2171c$var$buildIterableEndpoint(path) {
    const base = $e1f0b8fa1ae2171c$var$isProductionDomain() ? "https://audience.adweek.com" : "https://audience-develop.adweek.com";
    return base + path;
}
const $e1f0b8fa1ae2171c$export$26105d6ea9faa05f = function(args) {
    const endpoint = $e1f0b8fa1ae2171c$var$buildIterableEndpoint('/wp-json/adw-zephr/v2/webinar-registration-to-iterable');
    if (!endpoint) throw new Error('No iterable endpoint');
    return new Promise((resolve, reject1)=>{
        fetch(endpoint, {
            method: 'POST',
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(args)
        }).then((response)=>{
            if (response.status !== 200) return reject1();
            return response.json();
        }).then((response)=>resolve(response)).catch((error)=>reject1(error));
    }).catch((error)=>console.error("sendDataToIterable: failed to POST data to Iterable endpoint", {
            endpoint: endpoint,
            payload: args
        }, error));
};
function $e1f0b8fa1ae2171c$var$sendRegistrationDataToBigQuery(queryString) {
    if (!adw?.webinar_meta?.bigquery_webhook) return;
    return fetch(`${adw.webinar_meta.bigquery_webhook}/?${queryString}`).then((response)=>{
        if (response.status !== 200) return reject();
        console.log(response);
    }).catch((error)=>console.error('Error in BigQuery Webhook', error));
}
const $e1f0b8fa1ae2171c$export$f2672416beab0424 = ({ email: email })=>{
    if (!email) return ``;
    if (adw?.webinar_meta?.registration_url) return `${adw.webinar_meta.auto_join_url}?emailAddress=${email}`;
    // To-Do: Update this function to use the registration_url post meta field for generating the webinar entry link if it's set, and remove legacy support for the old entry link format that relies on the event_id query param after confirming all clients have updated to the new flow 
    return `https://event.webcasts.com/starthere.jsp?ei=${adw.webinar_meta.event_id}&email=${email}`;
};
const $e1f0b8fa1ae2171c$export$2852d657e2a7d685 = (ref, options = {})=>{
    $e1f0b8fa1ae2171c$var$React.useEffect(()=>{
        if (typeof anime === 'function' && ref?.current !== 'undefined') anime({
            targets: ref.current,
            opacity: [
                0,
                1
            ],
            translateY: [
                10,
                0
            ],
            duration: 500,
            easing: 'easeOutQuad',
            ...options,
            complete: function(anim) {}
        });
    }, [
        ref
    ]);
};
/**
 * The localStorage listeners
 * @type {Map<string, Set<() => void>>}
 */ const $e1f0b8fa1ae2171c$var$localStorageListeners = new Map();
/**
 * Notify the localStorage listeners
 * @param {string} key - The key to notify the listeners
 */ function $e1f0b8fa1ae2171c$var$notifyLocalStorageListeners(key) {
    $e1f0b8fa1ae2171c$var$localStorageListeners.get(key)?.forEach((cb)=>cb());
}
/**
 * Get the value from the localStorage with a boolean check
 * @param {any} val - The value to check
 * @returns {any} The value from the localStorage
 */ function $e1f0b8fa1ae2171c$var$getValWithBoolCheck(val) {
    if (val === 'true' || val === 'false') return val === 'true';
    return val;
}
function $e1f0b8fa1ae2171c$export$e06aeb8d379fb85b(key, defaultVal) {
    const defaultValRef = $e1f0b8fa1ae2171c$var$React.useRef(defaultVal);
    const subscribe = $e1f0b8fa1ae2171c$var$React.useCallback((callback)=>{
        const listeners = $e1f0b8fa1ae2171c$var$localStorageListeners.get(key) ?? $e1f0b8fa1ae2171c$var$localStorageListeners.set(key, new Set()).get(key);
        listeners.add(callback);
        const handler = (e)=>{
            if (e.key === key || e.key === null) callback();
        };
        window.addEventListener('storage', handler);
        return ()=>{
            $e1f0b8fa1ae2171c$var$localStorageListeners.get(key)?.delete(callback);
            window.removeEventListener('storage', handler);
        };
    }, [
        key
    ]);
    const getSnapshot = $e1f0b8fa1ae2171c$var$React.useCallback(()=>localStorage.getItem(key), [
        key
    ]);
    const raw = $e1f0b8fa1ae2171c$var$React.useSyncExternalStore(subscribe, getSnapshot);
    const value = $e1f0b8fa1ae2171c$var$React.useMemo(()=>{
        if (raw === null) return defaultValRef.current;
        try {
            return $e1f0b8fa1ae2171c$var$getValWithBoolCheck(JSON.parse(raw));
        } catch  {
            return defaultValRef.current;
        }
    }, [
        raw
    ]);
    const setValue = $e1f0b8fa1ae2171c$var$React.useCallback((newVal)=>{
        try {
            localStorage.setItem(key, JSON.stringify(newVal));
            $e1f0b8fa1ae2171c$var$notifyLocalStorageListeners(key);
        } catch (e) {
            console.warn(`useStateWithClientStorage: failed to write key "${key}"`, e);
        }
    }, [
        key
    ]);
    return [
        value,
        setValue
    ];
}
const $e1f0b8fa1ae2171c$export$e01218ac5c35c80a = (ref)=>{
    $e1f0b8fa1ae2171c$var$React.useEffect(()=>{
        if (ref.current) {
            const elHeight = ref.current.getBoundingClientRect().height;
            if (typeof elHeight === 'number' && elHeight > 0) ref.current.style.minHeight = `${elHeight}px`;
        }
    }, [
        ref
    ]);
};


function $255c1106bde83c67$var$ThankYouWebinarReg({ email: email, thankYouMessage: thankYouMessage = "" }) {
    const enterTheWebinarLink = (0, $e1f0b8fa1ae2171c$export$f2672416beab0424)({
        email: email
    });
    const title = thankYouMessage ? thankYouMessage : "Thank you for registering.";
    const ref = React.useRef();
    (0, $e1f0b8fa1ae2171c$export$2852d657e2a7d685)(ref, {
        delay: 0
    });
    React.useEffect(()=>{
        const elRegTitle = document.querySelector('.webinar-reg-title');
        if (elRegTitle) elRegTitle.style.display = "none";
    }, []);
    return /*#__PURE__*/ React.createElement("div", {
        ref: ref,
        style: {
            opacity: '0'
        },
        id: "thank-you-webinar-app"
    }, /*#__PURE__*/ React.createElement("div", {
        id: "webinar-thank-you-msg",
        className: "d-flex flex-column justify-content-center",
        style: {
            minHeight: '25vh'
        }
    }, /*#__PURE__*/ React.createElement("h2", {
        className: " h3 mb-0 text-center font-heading"
    }, title), /*#__PURE__*/ React.createElement("p", {
        className: "my-3 text-center"
    }, "You can enter the Webinar up to 30 minutes prior to the start time."), /*#__PURE__*/ React.createElement("div", {
        className: "d-flex flex-column align-items-center mb-4"
    }, /*#__PURE__*/ React.createElement("a", {
        href: enterTheWebinarLink,
        target: "_blank",
        className: "bg-aw-webinar text-decoration-none rounded-pill px-3 py-2 text-uppercase text-white font-weight-bold text-small"
    }, "Enter the Webinar"))));
}
var $255c1106bde83c67$export$2e2bcd8739ae039 = $255c1106bde83c67$var$ThankYouWebinarReg;


function $0310c35c46c759b4$var$InlineLoginPrompter() {
    const ref = React.useRef();
    React.useEffect(()=>{
        if (ref?.current) $(ref.current).tooltip();
    }, []);
    const originalTitle = `
    <span class=''>Register faster by signing in and enabling autofill.</span>
    `;
    function handleLoginClick(e) {
        if (typeof window.setLoginFormDisplay === 'function') {
            e.preventDefault();
            setLoginFormDisplay(true);
        }
    }
    return /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("p", {
        id: "login-prompt-tooltip",
        ref: ref,
        "data-toggle": "webinar-signin-prompt-tooltip",
        "data-html": "true",
        title: "",
        "data-placement": "top",
        "data-original-title": originalTitle
    }, "Already an Adweek Member?", " ", /*#__PURE__*/ React.createElement("a", {
        className: "trigger-login-form",
        href: "/login",
        onClick: handleLoginClick
    }, "Sign In"), "."));
}
var $0310c35c46c759b4$export$2e2bcd8739ae039 = $0310c35c46c759b4$var$InlineLoginPrompter;



const { useState: $f28e4a76c0f7e70f$var$useState, useEffect: $f28e4a76c0f7e70f$var$useEffect, useRef: $f28e4a76c0f7e70f$var$useRef } = React;
function $f28e4a76c0f7e70f$var$SetPassword({ registeredEmail: registeredEmail, handleZephrAccCreation: handleZephrAccCreation, userPassword: userPassword, setUserPassword: setUserPassword, errorMessage: errorMessage, isBusy: isBusy, isSuccess: isSuccess, hasZephrUser: hasZephrUser, dismissSignUp: dismissSignUp, setPasswordIsStrong: setPasswordIsStrong, passwordIsStrong: passwordIsStrong }) {
    const ref = $f28e4a76c0f7e70f$var$useRef();
    (0, $e1f0b8fa1ae2171c$export$2852d657e2a7d685)(ref, {
        delay: 500,
        translateY: [
            50,
            0
        ]
    });
    return /*#__PURE__*/ React.createElement("div", {
        ref: ref,
        className: "mx-n4 py-md-4 p-4 bg-light-subtle border-top"
    }, isSuccess ? /*#__PURE__*/ React.createElement($f28e4a76c0f7e70f$var$ElAnimIn, null, /*#__PURE__*/ React.createElement("h4", {
        className: "font-heading h3 mb-4 text-center text-success"
    }, "Almost there!"), /*#__PURE__*/ React.createElement("p", {
        className: "text-sm text-center"
    }, "You have been sent an email to ", /*#__PURE__*/ React.createElement("span", {
        className: "bg-light border text-sm fw-medium p-1",
        style: {
            wordBreak: "break-word"
        }
    }, registeredEmail), " to verify your account.")) : hasZephrUser ? /*#__PURE__*/ React.createElement($f28e4a76c0f7e70f$var$ElAnimIn, null, /*#__PURE__*/ React.createElement("h4", {
        className: "font-heading h3 mb-4 text-center"
    }, "You already have an ADWEEK account."), /*#__PURE__*/ React.createElement("p", {
        className: "text-sm text-center"
    }, "Sign in to access your account with ", /*#__PURE__*/ React.createElement("span", {
        className: "bg-light border text-sm fw-medium p-1",
        style: {
            wordBreak: "break-word"
        }
    }, registeredEmail), ".")) : /*#__PURE__*/ React.createElement($f28e4a76c0f7e70f$var$ElAnimIn, null, /*#__PURE__*/ React.createElement("h4", {
        className: "h3 mb-0 text-center font-heading mb-3"
    }, "Finish setting up your free ", /*#__PURE__*/ React.createElement("span", {
        className: "text-aw-webinar"
    }, "ADWEEK "), "account."), /*#__PURE__*/ React.createElement("p", {
        className: "mb-4 text-sm"
    }, "Gain limited access to Adweek.com articles, videos and podcasts. PLUS, the Adweek Daily newsletter with must-read stories will be sent directly to your inbox."), /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("label", {
        className: " mb-2 pb-0 text-sm"
    }, "Email"), /*#__PURE__*/ React.createElement("input", {
        type: "text",
        className: " text-sm form-control",
        value: registeredEmail,
        readOnly: true,
        disabled: true
    })), /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("label", {
        className: "mt-3 mb-2 pb-0 text-sm"
    }, "Password"), /*#__PURE__*/ React.createElement("input", {
        className: "form-control",
        onChange: (e)=>setUserPassword(e.target.value),
        type: "password",
        onKeyUp: (e)=>e.key === 'Enter' && passwordIsStrong && !isBusy ? handleZephrAccCreation() : null
    })), /*#__PURE__*/ React.createElement($f28e4a76c0f7e70f$var$PasswordReguirements, {
        setPasswordIsStrong: setPasswordIsStrong,
        userPassword: userPassword
    }), /*#__PURE__*/ React.createElement("div", {
        className: "mt-4"
    }, /*#__PURE__*/ React.createElement($f28e4a76c0f7e70f$var$BtnCreateAccount, {
        isBusy: isBusy,
        disabled: !userPassword?.length || !passwordIsStrong,
        handleZephrAccCreation: handleZephrAccCreation
    }), /*#__PURE__*/ React.createElement("button", {
        type: "button",
        className: "btn btn-link text-secondary text-decoration-none ml-2",
        onClick: dismissSignUp
    }, "No thanks"))), errorMessage && /*#__PURE__*/ React.createElement($f28e4a76c0f7e70f$var$ErrorMessage, {
        message: errorMessage
    }));
}
var $f28e4a76c0f7e70f$export$2e2bcd8739ae039 = $f28e4a76c0f7e70f$var$SetPassword;
const $f28e4a76c0f7e70f$var$PasswordReguirements = ({ setPasswordIsStrong: setPasswordIsStrong, userPassword: userPassword })=>{
    const [hasUpperCase, setHasUpperCase] = $f28e4a76c0f7e70f$var$useState(false);
    const [hasSpecialChar, setHasSpecialChar] = $f28e4a76c0f7e70f$var$useState(false);
    const [hasNumber, setHasNumber] = $f28e4a76c0f7e70f$var$useState(false);
    const [hasLength, setHasLength] = $f28e4a76c0f7e70f$var$useState(false);
    $f28e4a76c0f7e70f$var$useEffect(()=>{
        hasUpperCase && hasSpecialChar && hasNumber && hasLength ? setPasswordIsStrong(true) : setPasswordIsStrong(false);
    }, [
        hasUpperCase,
        hasSpecialChar,
        hasNumber,
        hasLength
    ]);
    $f28e4a76c0f7e70f$var$useEffect(()=>{
        const hasUpperCase = /[A-Z]/.test(userPassword);
        setHasUpperCase(hasUpperCase);
        const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(userPassword);
        setHasSpecialChar(hasSpecialChar);
        const hasNumber = /[0-9]/.test(userPassword);
        setHasNumber(hasNumber);
        const hasLength = userPassword?.length >= 8;
        setHasLength(hasLength);
    }, [
        userPassword
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        className: "mt-4 text-sm"
    }, /*#__PURE__*/ React.createElement("span", {
        className: "font-weight-bold text-secondary"
    }, "Password must contain:"), /*#__PURE__*/ React.createElement("span", {
        className: `d-flex ${hasLength ? 'text-success ' : 'text-secondary'}`
    }, "At least 8 characters ", /*#__PURE__*/ React.createElement($f28e4a76c0f7e70f$var$Check, {
        show: hasLength
    })), /*#__PURE__*/ React.createElement("span", {
        className: `d-flex ${hasUpperCase ? 'text-success ' : 'text-secondary'}`
    }, "1 uppercase ", /*#__PURE__*/ React.createElement($f28e4a76c0f7e70f$var$Check, {
        show: hasUpperCase
    })), /*#__PURE__*/ React.createElement("span", {
        className: `d-flex ${hasNumber ? 'text-success ' : 'text-secondary'}`
    }, "1 number ", /*#__PURE__*/ React.createElement($f28e4a76c0f7e70f$var$Check, {
        show: hasNumber
    })), /*#__PURE__*/ React.createElement("span", {
        className: `d-flex ${hasSpecialChar ? 'text-success ' : 'text-secondary'}`
    }, "1 special character ", /*#__PURE__*/ React.createElement($f28e4a76c0f7e70f$var$Check, {
        show: hasSpecialChar
    })));
};
const $f28e4a76c0f7e70f$var$Check = ({ show: show })=>{
    const ref = $f28e4a76c0f7e70f$var$useRef();
    const prevShowVal = React.useRef(show);
    let tl = null;
    if (typeof anime === 'function') tl = anime.timeline({
        easing: 'easeInOutQuad',
        duration: 300
    });
    $f28e4a76c0f7e70f$var$useEffect(()=>{
        tl;
        if (typeof anime === 'function' && show !== prevShowVal.current) tl.add({
            targets: ref?.current,
            opacity: show ? [
                0,
                1
            ] : [
                1,
                0
            ],
            translateX: show ? [
                10,
                0
            ] : [
                0,
                10
            ]
        });
        prevShowVal.current = show;
    }, [
        show
    ]);
    return /*#__PURE__*/ React.createElement("svg", {
        ref: ref,
        height: "24",
        viewBox: "0 -960 960 960",
        width: "24",
        style: {
            opacity: 0
        }
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "currentColor",
        d: "M400-304 240-464l56-56 104 104 264-264 56 56-320 320Z"
    }));
};
const $f28e4a76c0f7e70f$var$BtnCreateAccount = ({ handleZephrAccCreation: handleZephrAccCreation, disabled: disabled, isBusy: isBusy })=>{
    const ref = $f28e4a76c0f7e70f$var$useRef();
    (0, $e1f0b8fa1ae2171c$export$e01218ac5c35c80a)(ref);
    return /*#__PURE__*/ React.createElement("button", {
        ref: ref,
        disabled: disabled || isBusy,
        onClick: handleZephrAccCreation,
        className: "webinar-create-account-btn btn rounded-0 border border-aw-webinar text-aw-webinar text-decoration-none px-3 py-2 text-uppercase bg-white font-weight-bold text-small"
    }, isBusy ? "Creating" : "Create Account");
};
const $f28e4a76c0f7e70f$var$ErrorMessage = ({ message: message })=>{
    const ref = $f28e4a76c0f7e70f$var$useRef();
    (0, $e1f0b8fa1ae2171c$export$2852d657e2a7d685)(ref);
    return /*#__PURE__*/ React.createElement("div", {
        ref: ref,
        className: "alert alert-warning  mt-4",
        role: "alert"
    }, message);
};
const $f28e4a76c0f7e70f$var$ElAnimIn = ({ children: children })=>{
    const ref = $f28e4a76c0f7e70f$var$useRef();
    (0, $e1f0b8fa1ae2171c$export$2852d657e2a7d685)(ref);
    return /*#__PURE__*/ React.createElement("div", {
        ref: ref
    }, children);
};



// Mapping the keys between the form and the user profile
const $803aebb47a304bf7$export$aa66bfe69531dd12 = [
    {
        userProfileKey: "first-name",
        formInputId: "form_input_custom1"
    },
    {
        userProfileKey: "last-name",
        formInputId: "form_input_custom2"
    },
    {
        userProfileKey: "email",
        formInputId: "form_input_custom3"
    },
    {
        userProfileKey: "company",
        formInputId: "form_input_custom4"
    },
    {
        userProfileKey: "business-type",
        formInputId: "form_input_custom5"
    },
    {
        userProfileKey: "job-levelseniority",
        formInputId: "form_input_custom6"
    },
    {
        userProfileKey: "job-function",
        formInputId: "form_input_custom7"
    },
    {
        userProfileKey: "title",
        formInputId: "form_input_custom8"
    },
    {
        userProfileKey: "country",
        formInputId: "form_input_custom9"
    },
    {
        userProfileKey: "state",
        formInputId: "form_input_custom11"
    },
    {
        userProfileKey: "phone",
        formInputId: "form_input_custom12"
    }
];
const $803aebb47a304bf7$export$42c7fb3c4eb7b9c3 = {
    existing: "You are already registered.",
    success: "Thank you for registering."
};
const $803aebb47a304bf7$export$e8a84ecdc71876f3 = "ZI2404WREG";


const { useState: $ffb8f43ff78401e5$var$useState, useEffect: $ffb8f43ff78401e5$var$useEffect, useCallback: $ffb8f43ff78401e5$var$useCallback, useRef: $ffb8f43ff78401e5$var$useRef } = window.React;
// Webinar.net webinar ID
let $ffb8f43ff78401e5$var$idFromSubURL = null;
if ("string" === typeof adw?.webinar_meta?.registration_url && adw.webinar_meta.registration_url.length > 0) {
    let parts = adw.webinar_meta.registration_url.split('/');
    // Remove empty values
    parts = parts.filter((part)=>part.length > 0);
    $ffb8f43ff78401e5$var$idFromSubURL = parts[parts.length - 1];
}
const $ffb8f43ff78401e5$var$localStoragePrefix = 'webinar_user_';
const $ffb8f43ff78401e5$var$webcasts_events_key = $ffb8f43ff78401e5$var$idFromSubURL !== null ? $ffb8f43ff78401e5$var$idFromSubURL : String(adw?.webinar_meta?.event_id) || 'undefined';
const $ffb8f43ff78401e5$var$passwordPendingKey = `${$ffb8f43ff78401e5$var$localStoragePrefix}passwordPending_${$ffb8f43ff78401e5$var$webcasts_events_key}`;
const $ffb8f43ff78401e5$var$isDebugMode = new URLSearchParams(window.location.search).has('debug');
function $ffb8f43ff78401e5$var$WebinarApp() {
    const [registeredEmail, setRegisteredEmail] = (0, $e1f0b8fa1ae2171c$export$e06aeb8d379fb85b)(`${$ffb8f43ff78401e5$var$localStoragePrefix}registeredEmail_${$ffb8f43ff78401e5$var$webcasts_events_key}`, null);
    const [regFormIsVisible, setRegFormIsVisible] = $ffb8f43ff78401e5$var$useState(false);
    const [submittingForm, setSubmittingForm] = $ffb8f43ff78401e5$var$useState(false);
    const [showPasswordCreation, setShowPasswordCreation] = $ffb8f43ff78401e5$var$useState(false);
    const [hasZephrUser, setHasZephrUser] = (0, $e1f0b8fa1ae2171c$export$e06aeb8d379fb85b)(`${$ffb8f43ff78401e5$var$localStoragePrefix}hasZephrUser_${$ffb8f43ff78401e5$var$webcasts_events_key}`, false);
    const [signUpDismissed, setSignUpDismissed] = (0, $e1f0b8fa1ae2171c$export$e06aeb8d379fb85b)(`${$ffb8f43ff78401e5$var$localStoragePrefix}signUpDismissed_${$ffb8f43ff78401e5$var$webcasts_events_key}`, false);
    const [formFields, setFormFields] = (0, $e1f0b8fa1ae2171c$export$e06aeb8d379fb85b)(`${$ffb8f43ff78401e5$var$localStoragePrefix}formFields_${$ffb8f43ff78401e5$var$webcasts_events_key}`, null);
    const [userPassword, setUserPassword] = $ffb8f43ff78401e5$var$useState(null);
    const [isLoggedIn, setIsLoggedIn] = $ffb8f43ff78401e5$var$useState(()=>!!Object.entries(window.awGetUserData?.() || {}).length);
    const skipNextUserExistenceCheck = $ffb8f43ff78401e5$var$useRef(false);
    const [errorMessage, setErrorMessage] = $ffb8f43ff78401e5$var$useState(null);
    const [isBusy, setIsBusy] = $ffb8f43ff78401e5$var$useState(false);
    const [isSuccess, setIsSuccess] = $ffb8f43ff78401e5$var$useState(false);
    const [thankYouMessage, setThankYouMessage] = $ffb8f43ff78401e5$var$useState((0, $803aebb47a304bf7$export$42c7fb3c4eb7b9c3).success);
    const [passwordIsStrong, setPasswordIsStrong] = $ffb8f43ff78401e5$var$useState(false);
    $ffb8f43ff78401e5$var$useEffect(()=>{
        window.adw.webinar_app = {
            setRegisteredEmail: ({ email: email, message: message = null, skipUserExistenceCheck: skipUserExistenceCheck = false })=>{
                skipNextUserExistenceCheck.current = skipUserExistenceCheck;
                setRegisteredEmail(email);
                if (message) setThankYouMessage(message);
            },
            setRegFormIsVisible: setRegFormIsVisible,
            setSubmittingForm: setSubmittingForm,
            setShowPasswordCreation: setShowPasswordCreation,
            setHasZephrUser: setHasZephrUser,
            setFormFields: setFormFields,
            setIsLoggedIn: setIsLoggedIn
        };
        window.dispatchEvent(new Event("adw.webinar_app.ready"));
    }, []);
    $ffb8f43ff78401e5$var$useEffect(()=>{
        localStorage.removeItem($ffb8f43ff78401e5$var$passwordPendingKey);
        if (skipNextUserExistenceCheck.current) {
            skipNextUserExistenceCheck.current = false;
            return;
        }
        if (!registeredEmail || signUpDismissed || hasZephrUser || isLoggedIn) return;
        let ignore = false;
        (0, $e1f0b8fa1ae2171c$export$4bb8fcd6ff31955b)(registeredEmail).then((exists)=>{
            if (ignore) return;
            if (exists) setHasZephrUser(true);
            else setShowPasswordCreation(true);
        }).catch(()=>{
            if (!ignore) setShowPasswordCreation(true);
        });
        return ()=>{
            ignore = true;
        };
    }, [
        registeredEmail,
        signUpDismissed,
        hasZephrUser,
        isLoggedIn,
        setHasZephrUser
    ]);
    $ffb8f43ff78401e5$var$useEffect(()=>{
        (0, $e1f0b8fa1ae2171c$export$6f3bb5b44fd52b9a)(regFormIsVisible);
    }, [
        regFormIsVisible
    ]);
    $ffb8f43ff78401e5$var$useEffect(()=>{
        // Remove Digioh form wrapper
        if (registeredEmail) (0, $e1f0b8fa1ae2171c$export$bdc7c5cd37699390)();
        const elFloatingBtnWrapper = document.querySelector('.webinar .fixed-button-wrapper');
        if (elFloatingBtnWrapper) {
            elFloatingBtnWrapper.classList.remove('d-flex');
            elFloatingBtnWrapper.classList.add('d-none');
        }
    }, [
        registeredEmail
    ]);
    const isRequestInFlight = $ffb8f43ff78401e5$var$useRef(false);
    const handleZephrAccCreation = $ffb8f43ff78401e5$var$useCallback(async ()=>{
        if (isRequestInFlight.current) return;
        isRequestInFlight.current = true;
        setErrorMessage(null);
        setIsBusy(true);
        try {
            const copyFormFields = {
                ...formFields
            };
            if (!('sid' in copyFormFields)) copyFormFields['sid'] = (0, $803aebb47a304bf7$export$e8a84ecdc71876f3);
            const messageAndTrackingIdObject = await (0, $e1f0b8fa1ae2171c$export$82de835bb8638b43)({
                fieldValues: copyFormFields,
                email: registeredEmail,
                password: userPassword
            });
            if (messageAndTrackingIdObject?.status === 409) {
                setErrorMessage('This email already has an ADWEEK account.');
                setIsSuccess(false);
                setHasZephrUser(true);
                return;
            }
            if (!messageAndTrackingIdObject?.ok) {
                setErrorMessage(messageAndTrackingIdObject?.message || 'Unable to create your ADWEEK account.');
                setIsSuccess(false);
                return;
            }
            setHasZephrUser(true);
            try {
                await (0, $e1f0b8fa1ae2171c$export$d2da082481fe41f)({
                    email: registeredEmail,
                    action: 'register'
                });
                setErrorMessage(null);
                setIsSuccess(true);
            } catch (err) {
                console.error("Token exchange failed after registration", err);
                setErrorMessage('Your account was created, but we could not send the verification email. Use "Sign in" to request a login link.');
            }
        } catch (err) {
            console.error("Error in Zephr Registration", err);
            setErrorMessage('Unable to create your ADWEEK account.');
        } finally{
            setIsBusy(false);
            isRequestInFlight.current = false;
        }
    }, [
        registeredEmail,
        formFields,
        userPassword,
        setHasZephrUser
    ]);
    const dismissSignUp = $ffb8f43ff78401e5$var$useCallback(()=>{
        setShowPasswordCreation(false);
        setSignUpDismissed(true);
    }, [
        setSignUpDismissed
    ]);
    return /*#__PURE__*/ React.createElement("div", null, $ffb8f43ff78401e5$var$isDebugMode && /*#__PURE__*/ React.createElement("div", {
        className: "alert alert-info"
    }, /*#__PURE__*/ React.createElement("p", null, /*#__PURE__*/ React.createElement("strong", null, "Debug Mode Enabled")), /*#__PURE__*/ React.createElement("p", null, "localStorage Key for registeredEmail: ", `${$ffb8f43ff78401e5$var$localStoragePrefix}registeredEmail_${$ffb8f43ff78401e5$var$webcasts_events_key}`), /*#__PURE__*/ React.createElement("p", null, "registeredEmail: ", registeredEmail), /*#__PURE__*/ React.createElement("p", null, "regFormIsVisible: ", regFormIsVisible.toString()), /*#__PURE__*/ React.createElement("p", null, "submittingForm: ", submittingForm.toString()), /*#__PURE__*/ React.createElement("p", null, "showPasswordCreation: ", showPasswordCreation.toString()), /*#__PURE__*/ React.createElement("p", null, "hasZephrUser: ", hasZephrUser.toString()), /*#__PURE__*/ React.createElement("p", null, "signUpDismissed: ", signUpDismissed.toString()), /*#__PURE__*/ React.createElement("p", null, "formFields: ", JSON.stringify(formFields)), /*#__PURE__*/ React.createElement("p", null, "isLoggedIn: ", isLoggedIn?.toString())), !isLoggedIn && !(showPasswordCreation || registeredEmail) && /*#__PURE__*/ React.createElement((0, $0310c35c46c759b4$export$2e2bcd8739ae039), null), !registeredEmail?.length && submittingForm && /*#__PURE__*/ React.createElement($ffb8f43ff78401e5$var$Loader, null), registeredEmail && /*#__PURE__*/ React.createElement((0, $255c1106bde83c67$export$2e2bcd8739ae039), {
        email: registeredEmail,
        thankYouMessage: thankYouMessage
    }), showPasswordCreation && registeredEmail && /*#__PURE__*/ React.createElement((0, $f28e4a76c0f7e70f$export$2e2bcd8739ae039), {
        userPassword: userPassword,
        setUserPassword: setUserPassword,
        handleZephrAccCreation: handleZephrAccCreation,
        dismissSignUp: dismissSignUp,
        registeredEmail: registeredEmail,
        errorMessage: errorMessage,
        isBusy: isBusy,
        isSuccess: isSuccess,
        hasZephrUser: hasZephrUser,
        passwordIsStrong: passwordIsStrong,
        setPasswordIsStrong: setPasswordIsStrong
    }));
}
function $ffb8f43ff78401e5$var$Loader() {
    return /*#__PURE__*/ React.createElement("div", {
        className: "row justify-content-center my-2"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "col-12 text-center"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "spinner-border mx-auto",
        role: "status"
    }, /*#__PURE__*/ React.createElement("span", {
        className: "sr-only"
    }))));
}
var $ffb8f43ff78401e5$export$2e2bcd8739ae039 = $ffb8f43ff78401e5$var$WebinarApp;




async function $f9ccc1fa0d22629a$var$initConvertrFormForWebinar() {
    const BlaizeSDK = window.BlaizeSDK;
    const isUserLoggedIn = !!Object.entries(window.awGetUserData?.() || {}).length;
    const containerSelector = '#digioh-form-wrapper';
    const setRegisteredEmail = (args)=>{
        if (typeof window?.adw?.webinar_app?.setRegisteredEmail === 'function') window.adw.webinar_app.setRegisteredEmail(args);
    };
    const setHasZephrUser = (val)=>{
        if (typeof window?.adw?.webinar_app?.setHasZephrUser === 'function') window.adw.webinar_app.setHasZephrUser(val);
    };
    const setFormFields = (val)=>{
        if (typeof window?.adw?.webinar_app?.setFormFields === 'function') window.adw.webinar_app.setFormFields(val);
    };
    const setShowPasswordCreation = (val)=>{
        if (typeof window?.adw?.webinar_app?.setShowPasswordCreation === 'function') window.adw.webinar_app.setShowPasswordCreation(val);
    };
    const setIsLoggedIn = (val)=>{
        if (typeof window?.adw?.webinar_app?.setIsLoggedIn === 'function') window.adw.webinar_app.setIsLoggedIn(val);
    };
    const setRegFormIsVisible = (val)=>{
        if (typeof window?.adw?.webinar_app?.setRegFormIsVisible === 'function') window.adw.webinar_app.setRegFormIsVisible(val);
    };
    const setSubmittingForm = (val)=>{
        if (typeof window?.adw?.webinar_app?.setSubmittingForm === 'function') window.adw.webinar_app.setSubmittingForm(val);
    };
    try {
        const email = await getEmail();
        const emailFromClientSide = (0, $e1f0b8fa1ae2171c$export$c52aecb04e8f29cd)();
        if (emailFromClientSide) {
            setRegisteredEmail({
                email: emailFromClientSide,
                message: (0, $803aebb47a304bf7$export$42c7fb3c4eb7b9c3).existing
            });
            adw.webinar_meta.is_registered = true;
        } else if (email) {
            setIsLoggedIn(true);
            try {
                const registrationStatus = await getRegistrationStatus({
                    email: email
                });
                if (registrationStatus) {
                    setRegisteredEmail({
                        email: email,
                        message: (0, $803aebb47a304bf7$export$42c7fb3c4eb7b9c3).existing
                    });
                    adw.webinar_meta.is_registered = true;
                } else loadForm();
            } catch (err) {
                console.log("error getting registration status", err);
                throw err;
            }
        } else {
            // Not Registered
            // Register User on Zephr and on Webcasts
            adw.can_register_on_zephr = true;
            loadForm();
        }
    } catch (err) {
        console.error("error getting email", err);
        loadForm();
    }
    async function getEmail() {
        return new Promise((resolve, reject)=>{
            adw.is_signed_in = isUserLoggedIn || false;
            if (!isUserLoggedIn || !BlaizeSDK) return resolve(false);
            BlaizeSDK.getAccount((error, account)=>{
                if (error) {
                    console.error("BlaizeSDK. Failed to pull the user account:", error);
                    return reject(error);
                }
                const userEmailAddress = account["identifiers"]["email_address"];
                resolve(userEmailAddress);
            });
        });
    }
    function getRegistrationStatus({ email: email }) {
        return new Promise((resolve, reject)=>{
            if (!email) return reject('No email provided to check registration status.');
            if (adw?.webinar_meta?.registration_url) {
                const queryParams = new URLSearchParams();
                const postId = Number(adw?.post?.ID || 0);
                if (postId) queryParams.set('post_id', postId);
                else queryParams.set('registration_url', adw.webinar_meta.registration_url);
                queryParams.set('email', email);
                fetch(`${window.location.origin}/wp-json/adw_webinar_registration/v1/registration/?${queryParams.toString()}`).then((response)=>{
                    if (response.status !== 200) return reject();
                    return response.json();
                }).then((result)=>{
                    const isRegistered = !!result?.joinUrl || !!result?.autoJoinUrl || !!result?.is_registered;
                    if (isRegistered) {
                        (0, $e1f0b8fa1ae2171c$export$680d6313e5f8249a)(email);
                        return resolve(true);
                    }
                    return reject(result);
                }).catch((error)=>reject(error));
                return;
            }
            fetch(`${window.location.origin}/wp-json/adw-webcasts/v1/check_registration_status/?email=${email}&event_id=${adw.webinar_meta.event_id}`).then((response)=>{
                if (response.status !== 200) return reject();
                return response.json();
            }).then((result)=>{
                if (result?.is_registered) {
                    (0, $e1f0b8fa1ae2171c$export$680d6313e5f8249a)(email);
                    return resolve(result?.is_registered);
                }
                return reject(result);
            }).catch((error)=>reject(error));
        });
    }
    if (!adw?.webinar_meta?.event_id && !adw?.webinar_meta?.registration_url) console.error('Event ID not found. Could not complete registration check.');
    function getCurrentSlug() {
        const pathname = window.location.pathname;
        const parts = pathname.split("/").filter(Boolean);
        return parts.pop() || null;
    }
    /**
     * Updates the user's Zephr profile with the provided field values, but only if they differ from the existing values.
     * @param {Record<string, string>} payload the values to update on user's Zephr profile
     * @returns {void}
     */ const updateFieldValuesOnZephr = (payload)=>{
        if (!isUserLoggedIn || !BlaizeSDK) return;
        /**
         * Callback function to update the profile with the new values, after comparing them with the existing values to avoid unnecessary updates.
         * @param {Record<string, string>} savedProfileDetails the current user's profile details pulled from Zephr
         * @returns {void}
         */ const update = (savedProfileDetails)=>{
            // Removing entries with unchanged values
            const filteredPayload = Object.fromEntries(Object.entries(payload).filter(([key, value])=>savedProfileDetails[key] !== value));
            // Do nothing if nothing changed
            if (!Object.entries(filteredPayload).length) return;
            // Updating the profile
            BlaizeSDK.updateProfile(filteredPayload, true, (error)=>{
                if (error) {
                    console.error("Failed to update profile details", error);
                    return;
                }
                console.log("Profile details has been updated successfully");
            });
        };
        // Pulling current user profile
        BlaizeSDK.getProfile((error, dataFromProfile)=>{
            if (error) {
                console.error("BlaizeSDK. Failed to pull the user profile", error);
                return;
            }
            update(dataFromProfile);
        });
    };
    const sendDataToParsely = ()=>{
        if (window?.PARSELY?.conversions?.trackLeadCapture) {
            window.PARSELY.conversions.trackLeadCapture("Webinar_Reg");
            console.log("Track window.parent.PARSELY");
        }
    };
    /**
     * Pre-populates the form with the user data
     * @param {HTMLIFrameElement|undefined} [iframeNode=undefined] - The iframe node to pre-populate
     * @returns {void}
     */ function populate(iframeNode) {
        if ((!isUserLoggedIn || !BlaizeSDK) && !iframeNode) return;
        BlaizeSDK?.getAccount((error, account)=>{
            if (error) {
                console.error("BlaizeSDK. Failed to pull the user account:", error);
                return;
            }
            const userEmail = account["identifiers"]["email_address"];
            BlaizeSDK?.getProfile((error, userProfile)=>{
                if (error) {
                    console.error("BlaizeSDK. Failed to pull the user profile:", error);
                    return;
                }
                (0, $803aebb47a304bf7$export$aa66bfe69531dd12).forEach(({ userProfileKey: userProfileKey, formInputId: formInputId })=>{
                    const field = iframeNode.contentDocument.querySelector(`#${formInputId}`);
                    if (!field) return;
                    if (userProfileKey === "email") {
                        field.value ||= userEmail;
                        field.setAttribute("disabled", "true");
                        field.style.opacity = 0.5;
                        field.style.cursor = "not-allowed";
                        return;
                    }
                    if (!(userProfileKey in userProfile)) return;
                    const value = userProfile[userProfileKey];
                    if (userProfileKey === "country" && window.ZEPHR_COUNTRY_VALUE_DICTIONARY && value in window.ZEPHR_COUNTRY_VALUE_DICTIONARY) {
                        field.value ||= window.ZEPHR_COUNTRY_VALUE_DICTIONARY[value];
                        field.dispatchEvent(new Event("change", {
                            bubbles: true
                        }));
                        return;
                    }
                    if (userProfileKey === "state" && window.ZEPHR_US_STATES_VALUE_DICTIONARY && value in window.ZEPHR_US_STATES_VALUE_DICTIONARY) {
                        field.value ||= window.ZEPHR_US_STATES_VALUE_DICTIONARY[value];
                        field.dispatchEvent(new Event("change", {
                            bubbles: true
                        }));
                        return;
                    }
                    field.value ||= value;
                });
            });
        });
    }
    /**
     * Loads the form, and adds event listeners to handle the form submission and display of the form.
     * @returns {void}
     */ function loadForm() {
        const container = document.querySelector(containerSelector);
        if (!container) {
            console.error("Container not found");
            return;
        }
        const form = document.createElement("div");
        form.id = "lightbox-inline-webinar-form";
        form.style.textAlign = 'center';
        form.style.opacity = '0';
        form.style.transition = 'opacity 100ms ease-in-out';
        container.prepend(form);
        const abortController = new AbortController();
        const { signal: signal } = abortController;
        // Listen for messages from the DIGIOH Custom JS
        window.addEventListener("message", ({ data: data })=>{
            if (data?.type === "iframe-loaded") {
                setRegFormIsVisible(true);
                const placeholder = document.getElementById('digioh-form-placeholder');
                if (placeholder) {
                    placeholder.style.opacity = '0';
                    placeholder.addEventListener('transitionend', ()=>placeholder.remove(), {
                        once: true
                    });
                }
                window.DIGIOH_API.clearDataLayer();
                // Dispatch event for GA4 plugin
                document.querySelector(containerSelector).dispatchEvent(new Event("aw_convertr_form_loaded"));
                populate(document.querySelector(containerSelector)?.querySelector?.("iframe"));
                return;
            }
            if (data?.type === "form-submit-data") {
                setSubmittingForm(true);
                handleSubmit(data.payload).finally(()=>{
                    setSubmittingForm(false);
                    setRegFormIsVisible(false);
                    abortController.abort();
                });
            }
        }, {
            signal: signal
        });
    }
    /**
     * Handles the form submission and display of the form.
     * @param {Record<string, string>} payload - The payload of the form submission.
     * @returns {Promise<void>}
     */ async function handleSubmit(payload) {
        // Dispatch event for GA4 plugin
        document.querySelector(containerSelector).dispatchEvent(new Event("aw_convertr_form_submitted"));
        /**
         * Gets the code corresponding to a value from zephr country and state dictionaries
         * @param {string} value - The value to look up
         * @param {Record<string, string>} dictionary - The dictionary to search
         * @returns {string|undefined} The corresponding code, or undefined if not found
         */ const getCodeFromValue = (value = "", dictionary = {})=>{
            if (!value || Object.entries(dictionary).length === 0) return undefined;
            const entry = Object.entries(dictionary).find(([, name])=>name === value);
            return entry?.[0];
        };
        /**
         * Zephr's business-type attribute schema (GET /v3/schema/users/business-type) expects the
         * exact label text as the attribute value, not the numeric codes from AW_Helpers::get_business_types()
         * (that list belongs to a separate, legacy registration system). DIGIOH's dropdown text matches
         * Zephr's valid values verbatim, except its bare "OTHER" option, which Zephr's schema lists as "Other".
         * @param {string} value - The raw DIGIOH business-type label
         * @returns {string|undefined} The Zephr-valid value, or undefined if empty
         */ const getBusinessTypeValue = (value = "")=>{
            if (!value) return undefined;
            return value.toLowerCase() === "other" ? "Other" : value;
        };
        const formattedPayload = {
            "first-name": payload.custom_1,
            "last-name": payload.custom_2,
            company: payload.custom_4,
            title: payload.custom_8,
            "job-function": payload.custom_7,
            "job-levelseniority": payload.custom_6,
            phone: payload.custom_12
        };
        // Only include business-type, country and state if they resolve to a Zephr-valid value
        if (payload.custom_5) {
            const businessTypeValue = getBusinessTypeValue(payload.custom_5);
            if (businessTypeValue) formattedPayload["business-type"] = businessTypeValue;
        }
        if (`${payload.custom_9}` !== "") {
            const countryCode = getCodeFromValue(payload.custom_9, window.ZEPHR_COUNTRY_VALUE_DICTIONARY);
            if (countryCode) formattedPayload.country = countryCode;
        }
        if (`${payload.custom_11}` !== "") {
            const stateCode = getCodeFromValue(payload.custom_11, window.ZEPHR_US_STATES_VALUE_DICTIONARY);
            if (stateCode) formattedPayload.state = stateCode;
        }
        const payloadExtra = {
            gdpr_adweek: payload.custom_14,
            gdpr_partners: payload.custom_14
        };
        if (payload.custom_10) payloadExtra.customField1 = payload.custom_10;
        if (payload.custom_13) payloadExtra.customField2 = payload.custom_13;
        if (payload.custom_17) payloadExtra.customField3 = payload.custom_17;
        sendDataToParsely();
        if (!payload.custom_3) return;
        const email = payload.custom_3;
        let zephrUserExistsPromise = null;
        if (window.adw.can_register_on_zephr) {
            setFormFields(formattedPayload);
            zephrUserExistsPromise = (0, $e1f0b8fa1ae2171c$export$4bb8fcd6ff31955b)(email).then((exists)=>({
                    exists: exists
                })).catch((error)=>({
                    error: error
                }));
        } else {
            // Update values on Zephr
            updateFieldValuesOnZephr(formattedPayload);
            setHasZephrUser(true);
        }
        const getRegistrantData = ()=>{
            const urlQuery = new URLSearchParams(window.location.search);
            const sti = urlQuery.get("sti") || "";
            const eventIdFromMeta = adw?.webinar_meta?.event_id || null;
            const eventIdFromRegistrationURL = adw?.webinar_meta?.registration_url ? adw.webinar_meta.registration_url.split('/').filter(Boolean).pop() : null;
            return {
                email: email,
                ei: eventIdFromMeta || eventIdFromRegistrationURL,
                fname: formattedPayload["first-name"],
                lname: formattedPayload["last-name"],
                company: formattedPayload.company,
                title: formattedPayload.title,
                state: formattedPayload?.state || "",
                country: formattedPayload?.country || "",
                phone: formattedPayload.phone,
                Business_Type: formattedPayload["business-type"] || "",
                Job_Function: formattedPayload["job-function"],
                Job_Level: formattedPayload["job-levelseniority"],
                // Send extra field data
                ...payloadExtra,
                sti: sti
            };
        };
        // Register user on webinar platform
        let webinarRegistrationSucceeded = false;
        try {
            const registrationResponse = await (0, $e1f0b8fa1ae2171c$export$14113472834e2950)(getRegistrantData());
            const hasRegistrationUrl = !!adw?.webinar_meta?.registration_url;
            if (hasRegistrationUrl) {
                if (registrationResponse?.errors) alert("Error in registration: " + registrationResponse.errors.join(", "));
                if (registrationResponse?.joinUrl) {
                    setRegisteredEmail({
                        email: email,
                        skipUserExistenceCheck: true
                    });
                    (0, $e1f0b8fa1ae2171c$export$680d6313e5f8249a)(email);
                    webinarRegistrationSucceeded = true;
                }
            } else {
                const isAlreadyRegistered = registrationResponse?.includes('User already registered');
                const isSuccess = registrationResponse?.includes('SUCCESS');
                if (isAlreadyRegistered) {
                    setRegisteredEmail({
                        email: email,
                        message: (0, $803aebb47a304bf7$export$42c7fb3c4eb7b9c3).existing,
                        skipUserExistenceCheck: true
                    });
                    (0, $e1f0b8fa1ae2171c$export$680d6313e5f8249a)(email);
                    webinarRegistrationSucceeded = true;
                } else if (isSuccess) {
                    setRegisteredEmail({
                        email: email,
                        message: (0, $803aebb47a304bf7$export$42c7fb3c4eb7b9c3).success,
                        skipUserExistenceCheck: true
                    });
                    (0, $e1f0b8fa1ae2171c$export$680d6313e5f8249a)(email);
                    webinarRegistrationSucceeded = true;
                } else {
                    alert(`Error in Webinars.net registration: ${JSON.stringify(registrationResponse)}`);
                    (0, $e1f0b8fa1ae2171c$export$6f3bb5b44fd52b9a)(true);
                }
            }
        } catch (err) {
            (0, $e1f0b8fa1ae2171c$export$6f3bb5b44fd52b9a)(true);
            console.error("Error in Webinar Registration", err);
        }
        if (webinarRegistrationSucceeded && zephrUserExistsPromise) {
            const { exists: exists, error: error } = await zephrUserExistsPromise;
            if (error) {
                setShowPasswordCreation(true);
                console.error("Error checking Zephr User existence", error);
            } else if (exists) setHasZephrUser(true);
            else setShowPasswordCreation(true);
        }
        // Send the registered user to Iterable
        try {
            const formId = getCurrentSlug();
            const boxName = (0, $e1f0b8fa1ae2171c$export$eae3ab9a391c6ffd)(formId);
            const sponsorName = (boxName || "").split("_")[0] || "Unknown";
            await (0, $e1f0b8fa1ae2171c$export$26105d6ea9faa05f)({
                eventName: adw?.post?.title,
                sponsorName: sponsorName,
                ...getRegistrantData()
            });
        } catch (err) {
            console.log("Error in webinar platform (to Iterable)", err);
        }
    }
}
document.addEventListener("DOMContentLoaded", ()=>{
    window.addEventListener("adw.webinar_app.ready", $f9ccc1fa0d22629a$var$initConvertrFormForWebinar, {
        once: true
    });
    const elAppRoot = document.getElementById("webinar-reg-app");
    if (elAppRoot) {
        const ReactDOM = window.ReactDOM;
        ReactDOM.client.createRoot(elAppRoot).render(/*#__PURE__*/ React.createElement((0, $ffb8f43ff78401e5$export$2e2bcd8739ae039), null));
    }
}, {
    once: true
});
window.initConvertrFormForWebinar = $f9ccc1fa0d22629a$var$initConvertrFormForWebinar;

})();
//# sourceMappingURL=index.js.map
